import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../partner/internalRequestReceiveApproval/ContextAPI';
import Index from '../partner/internalRequestReceiveApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerInternalRequestReceiveApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-internal-request-receive-approval'])
        return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
